import axiosClient from "@/config/api/axios";
import { INTEGRATION_ACCESS_REVIEWS } from "@/config/api/endpoints";

const reviewPath = (assistantMessageId, reviewId) =>
  `${INTEGRATION_ACCESS_REVIEWS}/${encodeURIComponent(assistantMessageId)}/${encodeURIComponent(reviewId)}`;

export async function fetchAccessReview(assistantMessageId, reviewId, signal) {
  const { data } = await axiosClient.get(
    reviewPath(assistantMessageId, reviewId),
    { signal },
  );
  return data;
}

export async function deferAccessReview(assistantMessageId, reviewId) {
  const { data } = await axiosClient.post(
    `${reviewPath(assistantMessageId, reviewId)}/defer`,
  );
  return data;
}

export async function startAccessReviewConnection(
  assistantMessageId,
  reviewId,
  toolkitSlug,
  { reconnect = false, workspaceId } = {},
) {
  const { data } = await axiosClient.post(
    `${reviewPath(assistantMessageId, reviewId)}/groups/${encodeURIComponent(toolkitSlug)}/connect`,
    { reconnect },
    { headers: workspaceId ? { "X-Workspace-Id": workspaceId } : undefined },
  );
  return data;
}
